import { useState, useEffect } from "react";

function useDevice() {
  const getDeviceType = () => {
    const width = window.innerWidth;
    if (width <= 768) {
      return { isMobile: true, isTablet: false, isDesktop: false };
    } else if (width <= 1024) {
      return { isMobile: false, isTablet: true, isDesktop: false };
    } else {
      return { isMobile: false, isTablet: false, isDesktop: true };
    }
  };

  const [device, setDevice] = useState(
    typeof window !== "undefined"
      ? getDeviceType()
      : { isMobile: false, isTablet: false, isDesktop: true }
  );

  useEffect(() => {
    const handleResize = () => {
      setDevice(getDeviceType());
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return device;
}

export default useDevice;
